import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const invoicingRoutes: RouteRecordRaw[] = [
  // Invoices
  {
    path: '/invoicing/invoices',
    name: 'invoices',
    component: () => import('@/modules/invoicing/views/InvoiceListView.vue'),
    meta: {
      permission: PERMISSIONS.INVOICING.VIEW,
      projectScoped: true,
    },
  },
  // Invoicing Clients
  {
    path: '/invoicing/clients',
    name: 'invoicing-clients',
    component: () => import('@/modules/invoicing/views/InvoicingClientListView.vue'),
    meta: {
      permission: PERMISSIONS.INVOICING.CLIENTS,
      projectScoped: true,
    },
  },
  {
    path: '/invoicing/clients/:id',
    name: 'invoicing-client-detail',
    component: () => import('@/modules/invoicing/views/InvoicingClientDetailView.vue'),
    meta: {
      permission: PERMISSIONS.INVOICING.CLIENTS,
      projectScoped: true,
    },
  },
]
